function isTruthyEnvFlag(value: string | undefined): boolean {
  if (!value) return false;
  return /^(1|true|yes|on)$/i.test(value.trim());
}

type DemoUiEnv = {
  DEV: boolean;
  VITE_ENABLE_DEMO_MODE?: string;
};

type DemoAutoEnv = DemoUiEnv & {
  VITE_ENABLE_LOCALHOST_AUTO_DEMO?: string;
};

export function isDemoUiEnabled(env: DemoUiEnv): boolean {
  if (env.DEV) return true;
  return isTruthyEnvFlag(env.VITE_ENABLE_DEMO_MODE);
}

export function shouldAutoActivateLocalDemo(
  hostname: string,
  env: DemoAutoEnv,
): boolean {
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
  if (!isLocalHost) return false;
  if (!isDemoUiEnabled(env)) return false;
  return isTruthyEnvFlag(env.VITE_ENABLE_LOCALHOST_AUTO_DEMO);
}
